// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"0af5bfa4","297":"9d752908","643":"ad780424","959":"79eadd6a"}[chunkId] + ".chunk.js";
};